import { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { sectionsToRole } from "../../app/roles";
import { setUser } from "./loginSlice"; 
import config from "../../config";

const { envs } = config;
const { login: apiPath } = config.endpoints;

const CallbackPage = () => {
  const redirectUri = `${window.location.protocol}//${window.location.host}/callback`;
  const location = useLocation(); 
  const dispatch = useDispatch();


  const fetchSections = useCallback(async (accessToken, refreshToken) => {
    try {
      const response = await fetch(envs.apiUrl + envs.apiPrefix + apiPath.getSections, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`, // Aggiungi l'access token
        },
      });
      if (!response.ok) {
        throw new Error("Errore nella risposta della sezione");
      }
      const data = await response.json();
      dispatch(setUser({ role: sectionsToRole[data.sections], access_token: accessToken, refresh_token: refreshToken }));
      // Memorizza le sezioni nello stato locale
    } catch (err) {
      console.error("Errore durante il caricamento delle sezioni:", err);
    } finally {
    }
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get("code");

    if (code) {
      fetch(envs.apiUrl + apiPath.userLogin, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          ...envs.keycloakSSO,
          redirect_uri: redirectUri,
          code: code,
        }),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then(data => {
          if (data?.error || data?.error_description) {
            throw new Error(data?.error + data?.error_description || "");
          } 
          if (data?.access_token) {
            fetchSections(data.access_token, data.refresh_token); 
          } else {
            console.error("Access token non trovato nella risposta");
          }
        })
        .catch((error) => {
          console.error("Errore durante l'ottenimento del token:", error);
        });
    }
  }, [location.search, redirectUri, fetchSections]); 

};

export default CallbackPage;
